import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./userDelete.css"
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const ModalUserDelete = ({userId}) => {
    const [confirmation, setConfirmation] = useState('');
    const [confirmed, setConfirmed] = useState(false);
    const navigate = useNavigate();

    const handleConfirmationChange = (e) => {
        setConfirmation(e.target.value);
        setConfirmed(e.target.value.toLowerCase() === 'удалить');
    };

    const handleDelete = () => {
        logger.debug(userId)
        if (confirmed) {
            axiosInstance.delete(`website/employee/kill/${userId}`)
                .then(response => {
                    logger.debug('Employee deleted successfully');
                    navigate('/settings/generate-code'); 

                })
                .catch(error => {
                    logger.error('Error deleting employee:', error);
                });
        }
    };

    return (
        <div className='UserDelete'>
            <p className='DeleteInfo'>ВНИМАНИЕ!</p>
            <p className='DeleteInfo'>Если вы удалите работника то удалится и вся информация о нем</p>
            <p className='DeleteInfo'>Введите слово "Удалить" для подтверждения удаления работника:</p>
            <input className='DeleteInput' type="text" value={confirmation} onChange={handleConfirmationChange} />
            <button className='DeleteBTN' onClick={handleDelete} disabled={!confirmed}>Удалить</button>
        </div>
    );
};

export default ModalUserDelete;
